export enum ERROR_PLACEHOLDERS {
  LOGIN_FIELDS_NOT_CORRECT = 'Email or password is not correct',
  EMAIL_FIELD_INVALID_FORMAT = 'Email should be in name@domain.com format',
}

export enum RESET_PASSWORD_URLS {
  REQUEST_RESET_PASSWORD = '/request_password_reset',
  RESET_PASSWORD = '/reset_password',
}

export enum STATUS_TYPES {
  SENT = 'sent',
}
